import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {ComissaoGamsComponent} from './comissao-gams.component';
import { CanalGamsComponent } from './canal-gams/canal-gams.component';
import {Path} from "../../util/path";
import {DropdownModule} from "primeng/dropdown";
import {ReactiveFormsModule} from "@angular/forms";
import {InputMaskModule} from "primeng/inputmask";
import {InputTextModule} from "primeng/inputtext";
import {Select} from "primeng/select";
import {Textarea} from "primeng/textarea";

const listaPaginas = [
  {path: Path.COMISSAO_GAMS_CANAL_ACOLHIMENTO, imagem: 'telefone.svg'},
];



const routes: Routes = [
  { path: '', component: ComissaoGamsComponent },
  {
    path: Path.COMISSAO_GAMS_CANAL_ACOLHIMENTO.caminho,
    loadChildren: () => import('./canal-gams/canal-gams.module').then(m => m.CanalGamsModule),
    data: [listaPaginas, Path.COMISSAO_GAMS_CANAL_ACOLHIMENTO]
  },
];

@NgModule({
  declarations: [
    CanalGamsComponent,

  ],
  exports: [
    CanalGamsComponent
  ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        SharedModule,
        DropdownModule,
        ReactiveFormsModule,
        InputMaskModule,
        InputTextModule,
        Select,
        Textarea,

    ]
})
export class ComissaoGamsModule { }
